/* eslint-disable react/prop-types */
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SearchIcon } from 'components/shared/DesignSystem/Icons';
import SnippetsList from './SnippetsList';
import { Button } from '@companycam/slab-web';

const Container = styled.div`
  background-color: white;
  padding: 0 24px 40px 48px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  background-color: white;
  position: sticky;
  top: 86px;
  padding: 24px 0 16px 0;
  z-index: 1000;
`;

const SearchBar = styled.div`
  flex: 1;
  margin-right: 24px;
  position: relative;

  input {
    font-size: 16px;
    padding: 16px 30px 16px 36px;
    border: solid 1px var(--cc_color_border_input_inactive);
  }
`;

const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 14px;
  left: 8px;
`;

defineMessages({
  searchPlaceholder: {
    id: 'Snippets.savedSnippets.searchPlaceholder',
    defaultMessage: 'Find a text snippet...',
    description: 'Placeholder for snippets placeholder',
  },
});

const SavedSnippets = ({
  snippets,
  selectedSnippet,
  isCreating,
  isDeleting,
  handleSearchChange,
  handleSnippetClick,
  handleUseSnippetClick,
  handleCreateClick,
  intl,
}) => {
  const { formatMessage } = intl;

  return (
    <Container>
      <Header>
        <SearchBar>
          <StyledSearchIcon
            color="var(--cc_color_text_nonessential"
            size="small"
          />
          <input
            placeholder={formatMessage({
              id: 'Snippets.savedSnippets.searchPlaceholder',
            })}
            onChange={handleSearchChange}
            type="text"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={!isCreating}
          />
        </SearchBar>
        <Button
          color="primary"
          design="minimal"
          icon={{
            name: 'plus',
            position: 'before',
          }}
          onClick={handleCreateClick}
          disabled={isCreating}
        >
          <FormattedMessage
            id="Snippets.savedSnippets.createBtn"
            defaultMessage="Create New"
            description="Button for creating new snippet"
          />
        </Button>
      </Header>

      <SnippetsList
        snippets={snippets}
        selectedSnippet={selectedSnippet}
        isCreating={isCreating}
        isDeleting={isDeleting}
        handleCreateClick={handleCreateClick}
        handleClick={handleSnippetClick}
        handleUseSnippetClick={handleUseSnippetClick}
      />
    </Container>
  );
};

export default injectIntl(SavedSnippets);
